import {
    SET_API_ENDPOINTS, SET_CANTON_DETAIL_SEARCH_VALUE,
    SET_ENTRIES,
    SET_SEARCH_LOCATION,
    SET_SEARCH_RESULTS,
    SET_SEARCH_RESULTS_LOADING_STATE,
} from '../../mutation-types';
import * as actions from './actions';
import * as getters from './getters';


const mutations = {
    [SET_API_ENDPOINTS](state, { api }) {
        state.api = api;
    },
    [SET_CANTON_DETAIL_SEARCH_VALUE](state, { value }) {
        state.cantonDetailSearchValue = value;
    },
    [SET_ENTRIES](state, { entries }) {
        state.entries = entries;
    },
    [SET_SEARCH_LOCATION](state, { bounds, center, query }) {
        if (query) {
            state.searchLocation = { bounds, center, query };
        } else {
            state.searchLocation = null;
        }
    },
    [SET_SEARCH_RESULTS](state, { searchResults }) {
        state.searchResults = searchResults;
    },
    [SET_SEARCH_RESULTS_LOADING_STATE](state, { isLoadingSearchResults }) {
        state.isLoadingSearchResults = isLoadingSearchResults;
    },
};


const state = {
    api: {},
    entries: [],
    searchResults: [],
    cantonDetailSearchValue: '',
    isLoadingSearchResults: false,
    searchLocation: null,
};


export default {
    namespaced: true,
    mutations,
    actions,
    getters,
    state,
};
